export default "__VITE_ASSET__qXGeMRPp__"